import { css } from '@emotion/react';
import { wplToken } from '@atlassiansox/wpl-token';
import { getColor } from '@atlassiansox/wpl-utils';

export const containerStyle = css`
  padding: ${wplToken('space.300')} 0;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${getColor('n50')};
  }
`;

export const lozengeStyle = css`
  font-weight: 500;
`;

export const mainContentStyle = css`
  display: flex;
  align-items: start;
  font-size: 16px;
  font-weight: 500;
  margin: ${wplToken('space.100')} 0;
  line-height: 24px;
`;

export const productTextStyle = css`
  display: flex;
  align-items: start;
  flex: 1 1 auto;
`;

export const productNameStyle = css`
  text-transform: capitalize;
  display: inline-block;
`;

export const totalCostStyle = css`
  text-align: right;
  flex-shrink: 0;
  margin-left: ${wplToken('space.300')};
`;

export const subContentStyle = css`
  display: flex;
  font-size: 14px;
  color: ${getColor('n300')};
  margin: ${wplToken('space.100')} 0 0;
  line-height: 18px;
`;

export const siteNameStyle = css`
  flex: 1 1 auto;
`;

export const userBreakdownStyle = css`
  text-align: right;
  flex-shrink: 0;
  margin-left: ${wplToken('space.300')};
`;
